export default (component) => {
  const initAria = component.methods.initAria

  component.methods.initAria = function () {
    initAria.call(this)
    this.triggerElm.setAttribute('aria-haspopup', 'listbox')
  }
}
